module.exports = __webpack_public_path__ + "img/rules.d58616c0.jpg";